<template>
    <select class="form-select form-control mb-2" v-model="selectedStatus">
        <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label }}</option>
    </select>
    <div class="withdrawal-rgt-container">
        <div class="table-responsive">
            <table class="table table-bordered withdraw-table" id="withdrawTable">
                <thead>
                    <tr>
                    <th>{{ $t('payment-type', 'Payment Type') }}</th>
                    <th>{{ $t('requested-amount', 'Requested Amount') }}</th>
                    <th>{{ $t('approved-amount', 'Approved Amount') }}</th>
                    <th>{{ $t('status', 'Status') }}</th>
                    <th>{{ $t('request-date', 'Request Date') }}</th>
                    <th>{{ $t('action-date', 'Action Date') }}</th>
                    <th>{{ $t('payment-method', 'Payment Method') }}</th>
                    <th>{{ $t('transaction-no', 'Transaction No') }}</th>
                    <th>{{ $t('reason', 'Reason') }}</th>
                    <th>{{ $t('attachments', 'Attachments') }}</th>
                </tr>
                </thead>
                <tbody v-if="historyData && historyData.length > 0" id="depositTableData">
                <tr v-for="item in historyData" :key="item" class="text-center">
                    <td>{{ toTitleCaseWithSpaces(item?.type) }}</td>
                    <td >{{  item?.amount ? item?.amount : '-'}}</td>
                    <td >{{  ['approve_completed', 'reject_completed'].includes(item.status) ? item?.approved_amount : '-'}}</td>
                    <td class="text-start">
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="depositStatus" :class="getTransactionStatus(item?.status)?.class" >
                                {{ getTransactionStatus(item?.status)?.label  }}
                            </span>
                            <i v-if="item.status == 'pending'" @click="getWalletHistoryService()" :class="['fa', 'fa-refresh', {'fa-spin': spinClass}]" aria-hidden="true"></i>&nbsp;
                            <!-- <i v-if="item.status == 'pending'" @click="askConfirmation(item.c_a_tid)" :class="'fa fa-trash'" aria-hidden="true"></i> -->
                        </div>
                    </td>  
                    <td>{{ $dateTime.getLocalDate(item?.created_at, 'DD/MM/YYYY hh:mm:ss A') }}</td>
                    <td>
                        <span class="ms-1">
                            <template v-if="item?.action_at">
                                {{ $dateTime.sportItemDate(item.action_at, 'DD/MM/YYYY') }} | {{ $dateTime.sportItemDate(item.action_at, 'hh:mm:ss A') }}
                            </template>
                            <template v-else-if="item?.hold_at && item.status == 'hold' ">
                                {{ $dateTime.sportItemDate(item.hold_at, 'DD/MM/YYYY') }} | {{ $dateTime.sportItemDate(item.hold_at, 'hh:mm:ss A') }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </span>
                    </td>
                    <td>{{ item?.payment_method }}</td>
                    <td>{{ item?.transaction_id ?? '-' }}</td>
                    <td class="remarkTD">{{item.remark ? ShowNote(item.remark) : '-'}}</td>
                    <td class="wallet-view-btn-main" :class="{'tran-view-btn-sec': item.transaction_image_url}"> 
                        <button type="button" :class="{'view-tran-btn12': item?.transaction_image_url}"  @click="item?.transaction_image_url && openTransactionDetails(item)">{{item.transaction_image_url ? $t('view-details', 'View Details') : '-'}}
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody  v-if="!loading && historyData?.length == 0">
                <tr>
                    <td colspan="8" class="text-center">
                        {{$t('no-records-found', "No Record found")}}
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
    <Confirmation
        @confirm="confirmDelete"
        @cancel="$helper.closeModal('deleteConfirmationModal')"
    />
     <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="attchmentPreviewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header">
               <div class="thm-heading">
                  <h3>{{ $t('details','Details') }}</h3>
               </div>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <div v-if="currentImgLink">
                  <div class="row my-2" style="align-items: center;" >
                     <div class="col-12 text-center" >
                           <div v-for="(item,index) in transactionImageLists" :key="index">
                                <a :href="item" target="_blank">
                                    <img :src="item" alt="Preview" height="100%" width="100px" />
                                </a>
                           </div>
                     </div> <br>
                  </div>
               </div>
               <div v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { getWalletHistory, cancelRequest, getTransactionStatus } from '../services/walletHistory';import Confirmation from '@/shared/components/confirmation/Confirmation.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
export default {
    name: 'WalletHistory',
    components: {
		NoDataFound,
        Confirmation,
    },
    inject: ['walletHeader'],
    data() {
        return {
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('hold', 'Hold'), value: 'hold', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
                
            ],
            select_entries: 50,
            walletHistoryData: null,
            todayDate: new Date().toISOString().split('T')[0],
            spinClass: false,
            historyCallInterval: null,
            selectedStatus: 'all',
            selectedTransactionId: null,
            currentImgLink: null
        }
    },
    props: ['filterType'],
    computed: {
        transactionImageLists() {
            return this.currentImgLink?.split(',')
        },
        historyData() {
            let Data;
            if(this.selectedStatus == 'all'){
                Data = this.walletHistoryData;
            }
            else if(this.selectedStatus == 'processing'){
                Data = this.walletHistoryData?.filter((history) => ['reject_in_process','approve_in_process'].includes(history.status))
            }
            else if(!['all', 'processing'].includes(this.selectedStatus)){
                Data = this.walletHistoryData?.filter((history) => history.status == this.selectedStatus)
            }
            if(this.selectedTransactionType == 1){
                Data = this.walletHistoryData?.filter((history) => ['client_deposit','manual_deposit'].includes(history.type))
            }
            else if(this.selectedTransactionType == 2){
                Data = this.walletHistoryData?.filter((history) => ['client_withdrawal','manual_withdrawal'].includes(history.type))
            }
            return Data;
        },
    },
    created() {
          this.formDates.fromDate = this.$dateTime.getPreviousDate(30);
        this.formDates.toDate = this.$dateTime.getcurrentDate()
        this.getWalletHistoryService()       
    },
    methods: {
        getTransactionStatus,
        ShowNote(txt){
            if(txt == 'null' || txt == '' || txt == null) 
                return '-';
            else
                return txt;
        },
         async getWalletHistoryService(){
            try{
                this.spinClass = true;
                this.$store.dispatch('setGlobalLoader', true);
                let response = await getWalletHistory(this.formDates)
                this.$store.dispatch('setGlobalLoader', false);
                this.spinClass = false;
                if(response){
                    this.walletHistoryData = response?.walletHistoryData || [];
                }
            }catch(error){
                this.spinClass = false;
                this.$store.dispatch('setGlobalLoader', false);
                console.log(error)
            }
        },  
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        }, 
        async cancelRequest(id){
            try{
                let response = await cancelRequest(id);
                this.getWalletHistoryService()
            }
            catch(error){
                console.log('cancelRequest', error)
            }
        },
        askConfirmation(id) {
            this.selectedTransactionId = id
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await this.cancelRequest(this.selectedTransactionId);
        },
        openTransactionDetails(item) {
            this.currentImgLink = item?.transaction_image_url
            this.$helper.openModal('#attchmentPreviewModal')
        }
    },
}
</script>